import styled, { css } from 'styled-components';
import {
  ORB_DESIGN_SIZE,
  ORB_SIDE_TIPS_HIDDEN_QUERY,
  ORB_TIPS_ABOVE,
  ORB_TIPS_SIDE,
  type OrbTipPlacement,
} from './OrbBuddies.constants';

export const Root = styled.div<{ $size: number }>`
  position: relative;
  flex: none;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
`;

export const Layer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

const placementCss = (placement: OrbTipPlacement, size: number) => {
  if (placement === ORB_TIPS_SIDE) {
    return css`
      left: calc(100% - 6px);
      top: ${Math.round(22 * (size / ORB_DESIGN_SIZE))}px;
      width: max-content;
      max-width: 250px;

      @media ${ORB_SIDE_TIPS_HIDDEN_QUERY} {
        display: none;
      }
    `;
  }
  const edge = placement === ORB_TIPS_ABOVE ? 'bottom' : 'top';
  return css`
    left: 50%;
    ${edge}: calc(100% - 8px);
    width: max-content;
    max-width: min(250px, 90vw);
    translate: -50% 0;
  `;
};

export const Tip = styled.div<{ $placement: OrbTipPlacement; $size: number; $visible: boolean }>`
  position: absolute;
  z-index: 1;
  pointer-events: none;
  ${({ $placement, $size }) => placementCss($placement, $size)}
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: ${({ $visible }) => ($visible ? 'none' : 'translateY(6px) scale(0.96)')};
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
